import { FileDto } from "../app/model/api/types/dto";

export class FileViewModel {
  id?: string | null | undefined;
  fileName: string;
  mimeType: string;
  content: string;

  constructor(
    id: string | null | undefined,
    fileName: string,
    mimeType: string,
    content: string
  ) {
    this.id = id;
    this.fileName = fileName;
    this.mimeType = mimeType;
    this.content = content;
  }

  toDto(): FileDto {
    return {
      id: this.id,
      fileName: this.fileName,
      mimeType: this.mimeType,
      content: this.content,
    };
  }

  static mapFromDto(dto: FileDto): FileViewModel {
    return new FileViewModel(dto.id, dto.fileName, dto.mimeType, dto.content);
  }
}
